import React, { useEffect } from "react";
import "../css/homepage.css";
import AppleBadge from "../assets/images/apple-appstore-badge.svg";
import GooglePlayBadge from "../assets/images/googleplay.png";
import Footer from "../components/footer";
import HeaderHomepage from "../components/headerHomepage";

const MapliApp = (props) => {
  useEffect(() => {
    document.title = "Mapli - App Download";
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) {
      // Redirect to your Android app (Play Store or deep link)
      window.location.href =
        "https://play.google.com/store/apps/details?id=com.mapli";
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      // Redirect to your iOS app (App Store or deep link)
      window.location.href = "https://apps.apple.com/us/app/mapli/id6748616006";
    } else {
      // Fallback (maybe web version or landing page)
    }
  }, []);

  return (
    <div className='homePageContainer'>
      <HeaderHomepage />

      <div className='homePageMainContainer'>
        <div className='containerInfo'>
          {/* <p className='containerInfoText'>
            Reisevennen som hjelper deg finne frem til digge{" "}
            <div className='textHighlight' id='restaurants'>
              restauranter
            </div>
            , morsomme{" "}
            <div className='textHighlight' id='activities'>
              aktiviteter
            </div>{" "}
            og spennende{" "}
            <div className='textHighlight' id='events'>
              arrangementer
            </div>{" "}
            i nærheten!
          </p> */}
          <div className='textHighlight' id='downloadApp'>
            Last ned appen!
          </div>
          <div className='appstoreButtons'>
            <a
              href='https://apps.apple.com/us/app/mapli/id6748616006'
              style={{ cursor: "pointer" }}>
              <img src={AppleBadge} height='40px' style={{ marginRight: 5 }} />
            </a>
            <a
              href='https://play.google.com/store/apps/details?id=com.mapli'
              style={{ cursor: "pointer" }}>
              <img
                src={GooglePlayBadge}
                style={{ marginLeft: 5 }}
                height='39px'
              />
            </a>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default MapliApp;
